module.exports = __webpack_public_path__ + "static/Achi-2323230e6deca5240af884987a6c68c2.jpg";